import axios from 'axios';
import { reset as resetForm, initialize } from 'redux-form';
import { BASE_API, USER_TOKEN } from 'config/consts';
import _ from 'lodash';
import types from './types';

const URL = `${BASE_API}/station-hierarchies`;
const URL_HIERARCHY = `${BASE_API}/station-hierarchy`;

export const getList = (stationid) => {
  return (dispatch) => {
    dispatch({ type: types.LIST_LOAD, payload: true });
    axios
      .get(`${URL}/${stationid}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.LIST_FETCHED,
            payload: response,
          },
        ]);
      });
  };
};

export const getParentActions = (stationHierarchyId) => {
  return (dispatch) => {
    dispatch({ type: types.PARENT_ACTIONS_LOAD, payload: true });
    axios
      .get(`${URL_HIERARCHY}/${stationHierarchyId}/parent-actions`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          { type: types.PARENT_ACTIONS_FETCHED, payload: response.data },
          { type: types.PARENT_ACTIONS_LOAD, payload: false },
        ]);
      })
      .catch((error) => {
        dispatch({ type: types.PARENT_ACTIONS_LOAD, payload: false });
        try {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro ao buscar atividades: ${
                error.response?.data?.message || error.message
              }`,
              variant: 'error',
              open: true,
            },
          });
        } catch (err) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro ao buscar atividades', variant: 'error', open: true },
          });
        }
      });
  };
};

export const saveParentActions = (stationHierarchyId, actionIds) => {
  return (dispatch) => {
    dispatch({ type: types.PARENT_ACTIONS_SAVE_LOAD, payload: true });
    return axios
      .post(
        `${BASE_API}/station-hierarchies/actions/sync`,
        {
          station_hierarchy_id: stationHierarchyId,
          action_ids: actionIds,
        },
        {
          headers: {
            Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
          },
        }
      )
      .then(() => {
        dispatch([
          { type: types.PARENT_ACTIONS_SAVE_LOAD, payload: false },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Atividades vinculadas com sucesso',
              variant: 'success',
              open: true,
            },
          },
        ]);
      })
      .catch((error) => {
        dispatch({ type: types.PARENT_ACTIONS_SAVE_LOAD, payload: false });
        try {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro ao salvar vinculação: ${
                error.response?.data?.message || error.message
              }`,
              variant: 'error',
              open: true,
            },
          });
        } catch (err) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro ao salvar vinculação', variant: 'error', open: true },
          });
        }
        throw error; // Para propagar o erro
      });
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    axios
      .get(`${URL_HIERARCHY}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const initialValues = {
          ...response.data,
        };
        dispatch([
          {
            type: types.ITEM_DETAIL,
            payload: response.data,
          },
          initializeForm(initialValues),
        ]);
      });
  };
};

export const setDetail = (values) => {
  return (dispatch) => {
    const initialValues = {
      ...values,
      name: values.station_name,
    };
    console.log('values: ', initialValues);
    dispatch([
      {
        type: types.ITEM_DETAIL,
        payload: { data: values },
      },
      initializeForm(initialValues),
    ]);
  };
};

export const initializeForm = (values) => {
  return initialize('stationHierarchiesForm', values);
};

export const reset = () => {
  return resetForm('stationHierarchiesForm');
};

export const create = (values, router, firstTime) => {
  return submit(values, 'post', router, firstTime);
};

export const update = (values, router) => {
  return submit(values, 'put', router);
};

function submit(values, method, router = undefined, firstTime) {
  const id = values.id ? `${values.id}/` : '';
  return (dispatch) => {
    dispatch([
      { type: types.BUTTON_LOAD, payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    axios[method](`${URL}/${id}`, values, {
      headers: {
        Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
      },
      onUploadProgress: (progressEvent) =>
        dispatch([
          {
            type: 'SUBMIT_PROGRESS',
            payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
          },
        ]),
    })
      .then((response) => {
        /* dispatch([reset(), getList()]); */
        dispatch([
          { type: types.BUTTON_LOAD, payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
        ]);

        if (!_.isUndefined(router)) {
          if (firstTime) {
            router.push('/owner');
          } else {
            router.push('/owner/station-hierarchies');
          }
        }
      })
      .catch((e) => {
        dispatch([
          { type: types.BUTTON_LOAD, payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
        ]);

        try {
          if (e.response.data.error) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data.error}`,
                variant: 'error',
                open: true,
              },
            });
          } else {
            for (const i in e.response.data) {
              for (const j in e.response.data[i]) {
                dispatch({
                  type: 'SNACKBAR',
                  payload: {
                    message: `${i}: ${e.response.data.errors[i][j]}`,
                    variant: 'error',
                    open: true,
                  },
                });
              }
            }
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
}

export const remove = (id, resolve, reject, other = undefined) => {
  return (dispatch) => {
    dispatch({ type: types.LIST_LOAD, payload: false });
    axios
      .delete(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then(() => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
          {
            type: types.LIST_LOAD,
            payload: false,
          },

          resolve(),
        ]);
      })
      .catch((e) => {
        try {
          dispatch({
            type: 'SNACKBAR',
            payload: {
              message: `Erro: ${e.response.data.message}`,
              variant: 'error',
              open: true,
            },
          });
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
        reject();
      });
  };
};

export const setLoading = (bool) => {
  return (dispatch) => {
    dispatch({
      type: types.LIST_LOAD,
      payload: false,
    });
  };
};

export const fileRejected = () => {
  return (dispatch) => {
    dispatch({
      type: 'SNACKBAR',
      payload: {
        message: 'Erro: Imagem maior que 2MB',
        variant: 'error',
        open: true,
      },
    });
  };
};
